import { useCallback } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import {
  type CardInformativeScopedProps,
  DISPLAY_NAME,
  useCardInformativeContext,
} from '../../card-informative'
import { CardInformativeIconVariants } from './card-informative-icon.styles'

type CardInformativeIconProps = {}

export const CardInformativeIcon = (props: CardInformativeIconProps) => {
  const { __scopeCardInformative } =
    props as CardInformativeScopedProps<CardInformativeIconProps>

  const { type, iconName, variants } = useCardInformativeContext(
    DISPLAY_NAME,
    __scopeCardInformative
  )

  const mapper: Record<typeof variants, TIconProps['color']> = {
    positive: 'colorTextSuccessAlternative',
    informative: 'colorTextInformativeAlternative',
    warning: 'colorTextWarningAlternative',
    negative: 'colorTextDangerAlternative',
    neutral: 'colorTextNeutralAlternative',
  }

  const mapVariantColor = useCallback((): TIconProps['color'] => {
    return mapper[variants]
  }, [variants])

  return (
    <div {...props} className={CardInformativeIconVariants({ type })}>
      <Icon symbol={iconName} size="small" color={mapVariantColor()} />
    </div>
  )
}
